var brandLocatorExt = (function (brandId, premise) {
  var isLoaded = false;

   // NOTE: This script is hosted and run from the brand's website (Remy, Cointreau, Westland, MGR and LouisXIII);
   // It pulls the language and query details from the window (eg., remymartin.com) url, and creates and populates the brandlocator.com url for the iframe

  (function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
     (i[r].q = i[r].q || []).push(arguments)
  }, i[r].l = 1 * new Date(); a = s.createElement(o),
     m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'rbl_ga_ext');

  var loc = window.location.toString();
  var params = loc.split('?')[1];

  var baseUrl = 'https://brandlocator.engage360.co';
  if ((window.location.host === 'brandlocatorstaging.engage360.co')
        || (window.location.host.indexOf('preprod') > -1)
        || (window.location.host.indexOf('staging') > -1)) {
           baseUrl = 'https://brandlocatorstaging.engage360.co';
  } else if (window.location.host.indexOf('localhost') > -1) {
     baseUrl = 'http://localhost:3001';
  }

   function getParameterByName (name, url = window.location.href) {
       name = name.replace(/[\[\]]/g, '\\$&');
       var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
           results = regex.exec(url);
       if (!results) return null;
       if (!results[2]) return '';
       return decodeURIComponent(results[2].replace(/\+/g, ' '));
   }

  var querys = window.location.search;
  if (!querys) {
     querys = '?v=' + (new Date()).getTime();
  } else {
     querys = querys + '&v=' + (new Date()).getTime();
  }

  //premise is required for MGR, however, exclude if it was provided in the window URL
  if (premise && !querys.includes('premise')) {
     querys = querys + '&premise=' + premise;
  }

  var brandLocatorFrame = document.getElementById('brandLocatorFrame');
  // LXIII languages
  if (brandId === 'lxiii') {
     console.log(window.location.pathname);
     var langInPath = window.location.pathname.split('/')[1];
     console.log(langInPath);

     var langs = ['sc', 'tc', 'fr', 'sp', 'en', 'jp', 'ru'];
     if (langs.indexOf(langInPath) < 0) {
        langInPath = 'en';
     }

     // check if the "lang" parameter is present in the query string;  if yes, remove it.
     // The brand locator should display the language from the url path (ie., https://www.louisxiii-cognac.com/en-us/stores should display en-us)
     var _lang = getParameterByName('lang');
     if (_lang) {
         // remove this, and use the lang from the path
         querys = querys.replace('lang=' + _lang, '');
         querys = querys + '&lang=' + langInPath;
     } else {
         querys = querys + '&lang=' + langInPath;
     }

     baseUrl += "/" + brandId + querys;
     brandLocatorFrame.src = baseUrl;
  } else {
     baseUrl += "/rc/" + brandId + "/index.html" + querys;
     brandLocatorFrame.src = baseUrl;
  }

   brandLocatorFrame.onload = function(){
        isLoaded = true;
       //pass GA clientId to iframe
       var gaCode;
       if (brandId == 'lxiii'){
          gaCode = (location.host.startsWith('m.')  ? 'UA-9668241-5' : 'UA-9668241-4');
       } else {
          gaCode = gaMapper[brandId];
       }

       rbl_ga_ext('create', gaCode, 'auto');
       rbl_ga_ext(function(tracker) {
           var clientId = tracker.get('clientId');
           var frameWindow = brandLocatorFrame.contentWindow;
           frameWindow.postMessage(clientId, baseUrl);
       });
   };

  var gaMapper = {
     "ctr": "UA-11874475-2",
     "lxiii": "",
     "rm": "UA-9511858-4",
     "mgr": "UA-8568249-1",
     "westland": "UA-45276301-1"
  };

  setTimeout(function() {
     if (!isLoaded) {
        console.log('set brandlocator: ' + baseUrl);
        brandLocatorFrame.src = baseUrl;
     }
  }, 1500);
});
